/** List of departamentos */
export const GET_DEPARTAMENTOS_LIST_REQUEST = 'GET_DEPARTAMENTOS_LIST_REQUEST';
export const GET_DEPARTAMENTOS_LIST_SUCCESS = 'GET_DEPARTAMENTOS_LIST_SUCCESS';

/** departamentos form */
export const SET_DEPARTAMENTO_REQUEST = 'SET_DEPARTAMENTO_REQUEST';
export const SET_DEPARTAMENTO_SUCCESS = 'SET_DEPARTAMENTO_SUCCESS';
export const GET_DEPARTAMENTOS_MODAL = 'GET_DEPARTAMENTOS_MODAL';
export const HIDE_DEPARTAMENTOS_MODAL = 'HIDE_DEPARTAMENTOS_MODAL';
/** Error */
export const GET_DEPARTAMENTOS_ERROR = 'GET_DEPARTAMENTOS_ERROR';
